import { ModuleWithProviders } from '@angular/core/src/metadata/ng_module';
import { Routes, RouterModule } from '@angular/router';

import { ReportsComponent } from '../reports/reports.component';
import { ReviewComponent } from '../review/review.component';
import { AuthGuard } from '../common/auth.guard';

const REVIEWROUTES: Routes = [
    {
        path: 'review', component: ReportsComponent,
        children: [
            { path: 'list', component: ReviewComponent, canActivate: [AuthGuard] }
        ]
    }
];

export const REVIEWROUTING: ModuleWithProviders = RouterModule.forChild(REVIEWROUTES);



// WEBPACK FOOTER //
// ./src/app/review/review.routing.ts